import ENDPOINTS from '@utils/apiEndpoints';
import { axiosInstance } from '@utils/axiosInstance';
import { onApiError, onApiSuccess } from '@utils/utilities';

export const externalDeliveryDownloadFileDetailService = (histSeq) => {
  return axiosInstance
    .get(
      `${ENDPOINTS.ADMIN.OPERATION_HISTORY.EXTERNAL_DELIVERY.DETAIL}/${histSeq}`,
    )
    .then((response) => {
      return onApiSuccess(response);
    })
    .catch((error) => {
      return onApiError(error);
    });
};
